import { Colors, Services } from '@sigma-frontend-libs/commons'
import { defaultStringParser } from '@sigmasms/commons'

import { icons, permissionPresets, proxy, sendingPayloadValidator, validation } from '@/utils'

import render from './render'

const createPermissionPath = `advanced.${Services.patterns}.create`
const updatePermissionPath = `advanced.${Services.patterns}.update`

export default {
  name: 'Form',

  mixins: [ validation, proxy({ type: 'object' }) ],

  props: {
    isNew: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      check: undefined
    }
  },

  computed: {
    canUpdatePatternsAsAdmin() {
      return this.checkPermissions(updatePermissionPath)
    },
    canUpdatePatternsAsResellerUp() {
      return this.checkPermissions(updatePermissionPath, permissionPresets.resellerUp)
    },
    canCreatePatternsAsAdmin() {
      return this.checkPermissions(createPermissionPath)
    },
    canCreatePatternsAsMe() {
      return this.checkPermissions(createPermissionPath, 'me')
    },
    canCreatePatternsAsReseller() {
      return this.checkPermissions(createPermissionPath, 'reseller')
    },

    commentFields() {
      switch (true) {
        case this.canCreatePatternsAsMe: return [ 'comment' ]
        case this.canCreatePatternsAsReseller: return [ 'resellerComment', 'resellerCommentPrivate' ]
        case this.canCreatePatternsAsAdmin: return [ 'adminComment', 'adminCommentPrivate' ]
      }

      return []
    },

    validation() {
      return this.proxy.title && sendingPayloadValidator(this.proxy.type, this.proxy.payload)
    },

    patternValidation() {
      if (this.proxy.payload.text && this.check) {
        try {
          // https://tracker.yandex.ru/ONLINE-598
          const patternRegExp = defaultStringParser.makeRegExp(this.proxy.payload.text)

          return patternRegExp.test(this.check)
        } catch {
          return false
        }
      }
    },
    patternValidationIcon() {
      if (this.patternValidation === undefined) {
        return icons.help_outline
      }

      if (this.patternValidation) {
        return icons.check_circle_outline
      }

      return icons.block
    },
    patternValidationColor() {
      if (this.patternValidation === undefined) {
        return Colors.grey
      }

      if (this.patternValidation) {
        return Colors.success
      }

      return Colors.error
    },
    patternValidationTooltip() {
      if (this.patternValidation === undefined) {
        return this.getTranslate(`${Services.patterns}.tooltips.check.empty`)
      }

      if (this.patternValidation) {
        return this.getTranslate(`${Services.patterns}.tooltips.check.valid`)
      }

      return this.getTranslate(`${Services.patterns}.tooltips.check.invalid`)
    }
  },

  render
}
